import React, {useEffect, useState} from 'react';
import {TableCell} from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import useAppUtil from "../../../hooks/useAppUtil";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import {
  bulkDeleteEstablishmentMutation,
  deleteEstablishmentCache,
  getAllEstablishmentsQuery
} from "../../../gql/establishmentGql";
import {
  bulkDeleteChartImplementationMutation,
  deleteChartImplementationFromCache,
  getChartImplementationsQuery
} from "../../../gql/chartImplementationGql";
import {getDashBoard} from "../DashBoardAddView/DashBoardCreateUpdateForm";
import {bulkDeleteDashBoardMutation, deleteDashBoardFromCache, getDashBoardsQuery} from "../../../gql/dashBoardGql";
import {bulkDeleteChartBoardItemMutation} from "../../../gql/chartBoardItemGql";

const Results = ({className, ...rest}) => {
  const {
    userInDb,
    setReloadCustomBoardList,
    reloadCustomBoardList,
    setNavbarMobileReload,
  } = useAuth();
  const { addWarning, addError} = useAppUtil();
  const [itemSource, setItemSource] = useState(null);

  useEffect(() => {
    if (!userInDb) {
      return;
    }
    async function setItemSourceAsync() {
      let result = await executeQueryUtil(getDashBoardsQuery(userInDb.id));
      setItemSource(result);
    }
    setItemSourceAsync();
  }, [userInDb]);


  const getDashBoards = async () => {
    return await executeQueryUtil(getDashBoardsQuery(userInDb.id));
  }

  const getTableCellColumn = () => {
    return(
      <React.Fragment>
        <TableCell>
          {localStrings.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const getTableCell = (item) => {
    return(
      <React.Fragment>
        <TableCell>
          {item.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const deleteItems = async (ids) => {
    await executeMutationUtil(bulkDeleteDashBoardMutation(userInDb.id, ids));
    await deleteDashBoardFromCache(userInDb.id, ids);
    await setNavbarMobileReload();
    let itemUpdate = await getDashBoards();
    setItemSource(itemUpdate);
    setReloadCustomBoardList(!reloadCustomBoardList)
    //toto removeChartBoardItem
    // await executeMutationUtil(bulkDeleteChartBoardItemMutation(userInDb.id, ids));

    return true;
  }


  const sortOptions = [
    {
      value: 'name|asc',
      label: localStrings.name
    },
  ];

  return (
    <>
      { itemSource ?
        <GeneralResult
          className={className}
          getPathToData={(result) => result.data.getDashBoards}
          getTableCell={getTableCell}
          getTableCellColumn={getTableCellColumn}
          getEditLink={(item) => "/dashboard/dashboards/detail/" + item.id}
          deleteDialogText={localStrings.confirmMessage.deleteItem}
          deleteItemsFunction={deleteItems}
          deleteItemNotifMessage={localStrings.notif.dashboardDeleted}
          sortOptions={sortOptions}
          searchProperties={['name']}
          itemsSource={itemSource}
        >
        </GeneralResult>
        :
        <ClipLoaderComponent/>
      }
    </>
  )

};


export default Results;
